import "react";
import { ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/Select/SelectGroupValueSingle.tsx
var SelectGroupValueSingle = ({ color, label }) => /* @__PURE__ */ jsxs("div", {
	className: "mx-sm gap-x-sm inline-flex items-center",
	children: [!!color && /* @__PURE__ */ jsx(ColorSquare, { color }), /* @__PURE__ */ jsx("div", {
		className: "truncate text-sm",
		children: label
	})]
});
export { SelectGroupValueSingle };

//# sourceMappingURL=SelectGroupValueSingle.js.map